var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.breadCrumbs}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }